import { FC } from 'react'
import { SvgProps } from './svgProps'

const ArrowUpDownIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    width={width || 14}
    height={height || 13}
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_507_763)">
      <path
        d="M4.20001 11.8333V2.77614L5.80504 4.30473C6.0784 4.56509 6.52164 4.56509 6.79499 4.30473C7.06834 4.04439 7.06834 3.62227 6.79499 3.36193L3.99499 0.69526C3.72162 0.434913 3.2784 0.434913 3.00503 0.69526L0.205024 3.36193C-0.0683412 3.62227 -0.0683412 4.04439 0.205024 4.30473C0.478395 4.56509 0.921608 4.56509 1.19498 4.30473L2.80001 2.77614V11.8333C2.80001 12.2015 3.11341 12.5 3.50001 12.5C3.88661 12.5 4.20001 12.2015 4.20001 11.8333Z"
        fill={color || '#222222'}
      />
      <path
        d="M11.2 1.16666C11.2 0.798473 10.8866 0.5 10.5 0.5C10.1134 0.500007 9.8 0.798486 9.8 1.16668L9.80014 10.224L8.19496 8.69527C7.92161 8.43494 7.47836 8.43494 7.20501 8.69527C6.93166 8.9556 6.93166 9.37774 7.20501 9.63807L10.005 12.3047C10.0914 12.387 10.1947 12.4433 10.3043 12.4735C10.3444 12.4847 10.3859 12.4924 10.4286 12.4965C10.4521 12.4988 10.476 12.5 10.5001 12.5C10.5126 12.5 10.525 12.4997 10.5373 12.4991C10.72 12.49 10.8842 12.4141 11.0034 12.2967L13.795 9.63807C14.0683 9.37774 14.0683 8.9556 13.795 8.69527C13.5216 8.43494 13.0784 8.43494 12.805 8.69527L11.2001 10.2237L11.2 1.16666Z"
        fill={color || '#222222'}
      />
    </g>
    <defs>
      <clipPath id="clip0_507_763">
        <rect
          width="14"
          height="12"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default ArrowUpDownIcon
